import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { TransferDataService } from '../transfer-data.service';
import { FileTransfer } from '../model/fileTransfer.model';

@Component({
  selector: 'app-transfer-detail',
  templateUrl: './transfer-detail.component.html',
  styleUrls: ['./transfer-detail.component.css']
})
export class TransferDetailComponent implements OnInit {
  today: Date = new Date();
  resultTable: any[];
  //tableCustomerDetail: any[] = null;
  tableCustomerDetail: any = { AccountNameBank: null, BankBranchName: null, BankName: '' }
  fileTransfer: FileTransfer = null;
  cols: any[];
  arrFrom: any[] = [];
  selectedFrom: any = null
  arrTo: any[] = [];
  selectedTo: any = null
  msg: string = '';
  msgs: any[] = [];
  userDetails: any;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  listFundInstitutions: any[] = [];
  selectedFundInstitutionId: any = null;
  asyncCallsCounter: any = 0;
  ReportType: any = "regular";
  dateType: any = '1';

  constructor(private dataService: TransferDataService, private router: Router, private userService: UserService) { }
  ngOnInit() {
    this.asyncCallsCounter++;
    this.userService.getUserClaims().subscribe((result: any) => {
      this.asyncCallsCounter--;
      this.userDetails = result;
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.dataService.getCustomers().subscribe((result: any) => {
          this.listcustomer = result;
          this.listcustomer.unshift({ label: 'בחר מעסיק', value: null });
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
          });
      }
      else {
        this.selectedCustomerId = this.userDetails.CurrentCustomerIdentityNumber;
        this.funOnChange();
      }
    },
      (err: HttpErrorResponse) => {
        //this.asyncCallsCounter--;
        this.userDetails = null;
      });
    // this.cols = [
    //   // { field: 'IdentityNumber', header: 'ח.פ. קופה' },
    //   // { field: 'KupaName', header: 'שם קופה' },
    //   // { field: 'BankName', header: 'שם בנק' },
    //   // { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף' },
    //   // { field: 'MISPAR_CHESHBON', header: 'חשבון בנק' },
    //   // { field: 'MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM', header: 'אסמכתא' },
    //   // { field: 'TAARICH_ERECH_HAFKADA_LEKUPA', header: 'תאריך' }

    //   // { field: 'KOD_MEZAHE_KUPA_H_P', header: 'ח.פ. קופה' },
    //   { field: 'KupaName', header: 'שם קופה' },
    //   { field: 'BankName', header: 'שם בנק' },
    //   { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף' },
    //   { field: 'MISPAR_CHESHBON_KOLET', header: 'חשבון בנק' },
    //   { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סה"כ הפקדה' },
    //   { field: 'MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM', header: 'אסמכתא' },
    //   { field: 'TAARICH_ERECH_HAFKADA_LEKUPA', header: 'תאריך' }
    // ];

    this.cols = [
      { field: 'KupaName', header: 'שם קופה' },
      { field: 'BankName', header: 'שם בנק' },
      { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף' },
      { field: 'MISPAR_CHESHBON_KOLET', header: 'חשבון בנק' },
      { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סה"כ הפקדה' },
      { field: 'MonthBy', header: 'חודש שכר' }
    ];
  }

  getDate(): any {
    if (this.selectedCustomerId) {
      this.asyncCallsCounter++;
      this.dataService.getBuildDate(this.selectedCustomerId).subscribe((result: any) => {
        this.asyncCallsCounter--
        this.arrFrom = result;
        this.arrTo = result;
        if (this.arrFrom !== null) {
          if (this.arrFrom.length >= 12) {
            this.selectedFrom = this.arrFrom[this.arrTo.length - 12];
          }
          else {
            this.selectedFrom = this.arrFrom[0];
          }
        }
        else {
          this.selectedFrom = null;
        }
        //this.selectedFrom = this.arrFrom !== null ? this.arrFrom[0] : null;
        this.selectedTo = this.arrTo !== null ? this.arrTo[this.arrTo.length - 1] : null;
        //this.fundInstitutionSelected();
      }, (err: HttpErrorResponse) => {
        this.asyncCallsCounter--;
        this.showMessage('error', '', 'תקלה בקבלת תאריכים');
        this.initialization();
      });
    }
  }

  fundInstitutionSelected(): any {
    if (this.selectedCustomerId) {
      this.asyncCallsCounter++;
      this.dataService.getFundInstitution(this.selectedCustomerId).subscribe((result: any) => {
        this.asyncCallsCounter--;
        this.listFundInstitutions = result;
        this.listFundInstitutions.unshift({ label: 'הכל', value: null });
      },
        (err: HttpErrorResponse) => {
          this.asyncCallsCounter--;
          this.showMessage('error', '', 'תקלה בקבלת רשימת קופות לעובד');
        });
    }
  }

  // SearchReport(transfer: NgForm): void {

  //   transfer.value.selectedFundInstitutionId = transfer.value.selectedFundInstitutionId == null ? "" : transfer.value.selectedFundInstitutionId;
  //   transfer.value.selectedFundInstitutionId = transfer.value.selectedFundInstitutionId == null ? "" : transfer.value.selectedFundInstitutionId;

  //   this.selectedFundInstitutionId = this.selectedFundInstitutionId == null ? "" : this.selectedFundInstitutionId;
  //   this.selectedFundInstitutionId = this.selectedFundInstitutionId == null ? "" : this.selectedFundInstitutionId;
  //   this.selectedFundInstitutionId = this.selectedFundInstitutionId == null ? "" : this.selectedFundInstitutionId;

  //   this.dataService.getReportResult(transfer.value.toVal, transfer.value.fromVal).subscribe((data: FileTransfer) => {
  //     this.fileTransfer = data;
  //   }, (err: HttpErrorResponse) => {
  //     this.showMessage('error', '', 'לא ניתן להציג את הדוח ללא השדות חיפוש: מחודש ועד חודש');
  //   });
  // }

  getReport() {
    this.selectedTo = this.selectedTo === null ? "" : this.selectedTo;
    this.selectedFrom = this.selectedFrom === null ? "" : this.selectedFrom;
    this.selectedFundInstitutionId = this.selectedFundInstitutionId === null ? "" : this.selectedFundInstitutionId;
    this.selectedCustomerId = this.selectedCustomerId === null ? "" : this.selectedCustomerId;
    this.dataService.getReportResult(this.selectedTo, this.selectedFrom, this.selectedCustomerId, this.selectedFundInstitutionId, this.ReportType, this.dateType).subscribe((result: any) => {
      
      if (this.dateType=='1') {
        this.cols[5].header = 'חודש שכר';
      } else {
        this.cols[5].header = 'חוד דיווח';
      }


      this.resultTable = result;
      if (this.resultTable.length > 0) {
        this.dataService.getCustomerDetail(this.selectedCustomerId).subscribe((result2: any) => {
          this.tableCustomerDetail = result2;
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
          });
      }
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בהצגת הדוח');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });   //type='success'/'error'/'warn'/'success'
  }

  initialization(): void {
    this.arrFrom = [];
    this.arrTo = [];
    this.fileTransfer = null;
    this.resultTable = null;
  }

  funOnChange(): void {
    this.getDate();
    this.fundInstitutionSelected();
    this.resultTable = null;
  }
}


// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/TransferDetail/transfer-detail.component.ts